import { render, staticRenderFns } from "./action-category.vue?vue&type=template&id=802a9566&"
import script from "./action-category.vue?vue&type=script&lang=js&"
export * from "./action-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports